export default import.meta.ROLLDOWN_FILE_URL_tJTS3sigk873lADtH2o4ZQ